export default __webpack_public_path__ + "static/media/meal.3409e246.svg";